<template>
  <div class="row">
    <div class="col-8">
      <table class="min-w-full divide-y divide-gray-200">
        <tbody class="bg-white divide-y divide-gray-200">
        <draggable @change="changed" v-model="this.docs" tag="tbody" item-key="name">
          <template #item="{ element }">
            <tr class="movable">
              <td class="px-3 py-4" width="75%">{{ element.metadata.name }}</td>
              <td class="px-3 py-4 whitespace-nowrap">
                <div class="flex items-center whitespace-nowrap text-right text-sm font-medium space-x-4">
                  <a :href="element.metadata.file_path"
                     target="_blank"
                     class="font-medium text-uknar-primary hover:text-uknar-primary">
                    Download
                  </a>
                  <a v-if="element.metadata.delete_link" v-on:click="this.$parent.openDeleteModal(element.metadata.delete_link)"
                     class="font-medium text-rose-800 hover:text-rose-700 cursor-pointer">
                    Delete
                  </a>
                </div>
              </td>
            </tr>
          </template>
        </draggable>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "sortable-table",
  display: "Sortable Table",
  order: 8,
  components: {
    draggable
  },
  props: {
    documents: {
      type: Object,
      required: true
    },
    updateRoute: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      docs: [],
    };
  },
  created() {
    this.docs = this.documents;
  },
  methods: {
    changed: function () {
      this.updateDisplayOrder();
      setTimeout( this.persistDisplayOrder(), 200)
    },
    updateDisplayOrder: function () {
      this.docs.forEach(function (document, index) {
        document.display_order = index;
      })
    },
    persistDisplayOrder: function () {
      window.axios.post(this.updateRoute, this.docs)
          .then((res) => {
          })
          .catch(error => {
            console.log(error);
          });
    },
  },
  data() {
    return {
      dragging: false,
    };
  },
  mounted() {
    this.updateDisplayOrder()
    this.persistDisplayOrder()
  }
};
</script>
<style scoped>

.movable:hover {
  cursor: grab;
}

.movable:active {
  cursor: grabbing;
}
</style>
